<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Apply Filters</h3>
    <mat-icon
      fontSet="material-icons-round"
      class="close-icon"
      (click)="closeModal()"
      >close</mat-icon
    >
  </div>
  <div class="content">
    <div class="section" *ngIf="permissions?.USER_ADD || permissions?.USER_EDIT || permissions?.MANAGE_ALL_AUTHORITY">
      <h4 class="section-title">Filter by Assignment</h4>
      <div class="checkbox-group">
        <div class="checkbox-item">
          <input
            type="checkbox"
            class="kinput"
            [checked]="mainFilter.showOnlyAssignedToMe"
            (change)="updateCheckboxFilter('showOnlyAssignedToMe', $event)"
            [disabled]="isCheckboxDisabled('showOnlyAssignedToMe')"
            id="showOnlyAssignedToMe"
          />
          <label for="showOnlyAssignedToMe" class="checkbox-label" [class.disabled]="isCheckboxDisabled('showOnlyAssignedToMe')">
            Show only users assigned to me
            <mat-icon class="checkbox-icon" [matTooltip]="getHelpText('showOnlyAssignedToMe')" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>

    <div class="section">
      <h4 class="section-title">Filter by User Role</h4>
      <div class="checkbox-group">
        <div class="checkbox-item" *ngFor="let filter of roleFilters">
          <input
            type="checkbox"
            class="kinput"
            [checked]="mainFilter[filter.parameter]"
            (change)="updateCheckboxFilter(filter.parameter, $event)"
            [disabled]="isCheckboxDisabled(filter.parameter)"
            [id]="filter.parameter"
          />
          <label [for]="filter.parameter" class="checkbox-label" [class.disabled]="isCheckboxDisabled(filter.parameter)">
            {{ filter.text }}
          </label>
        </div>
      </div>
    </div>

    <div class="section" >
      <h4 class="section-title">Active/Inactive</h4>
      <div class="checkbox-group">
        <div class="checkbox-item">
          <input
            type="checkbox"
            class="kinput"
            [checked]="mainFilter.showInactiveMembers"
            (change)="updateCheckboxFilter('showInactiveMembers', $event)"
            id="showInactiveMembers"
          />
          <label for="showInactiveMembers" class="checkbox-label">
            Show inactive members
            <mat-icon class="checkbox-icon" [matTooltip]="getShowInactiveTooltip()" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="buttons">
    <app-new-button
      color="tonal"
      size="sm"
      customPadding="12px 16px"
      (clickHandler)="closeModal()"
    >
      Cancel
    </app-new-button>
    <app-new-button
      color="green"
      size="sm"
      leftIcon="done"
      customPadding="12px 16px"
      (clickHandler)="saveFilters()"
      [disabled]="!hasChanges()"
    >
      Save Filters
    </app-new-button>
  </div>
</div> 